import FooterLogo from '../../uber-assets/ROTY26_logo_small.jpg'; // '../../uber-assets/footer-ubereats-small-logo-black.svg';

export function Footer() {
    return (
        <footer>
            <div className='section-container'>
                <div className="content footer-container">
                    <FooterContent />
                </div>
            </div>
        </footer>
    )
}

export function FooterContent({isInMenu}) {
    return (
        <>
            <div className="footer-image-container">
                {/* <img className={`footer-logo${isInMenu ? ' in-menu' : ''}`} src={FooterLogo} alt="footer-logo" /> */}
                <p>This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</p>
                <p>All submitted data will be treated in accordance with our <a href="https://www.uber.com/legal/en/" target='_blank' rel="noreferrer">Privacy Policy</a> and <a href="https://messages.uber.com/public/messages/97f9a3fc-877f-4a5a-8f0d-7f7da6e4d97f" target='_blank' rel="noreferrer">Terms and Conditions.</a></p>
            </div>
            <div className={`footer-content${isInMenu ? ' in-menu' : ''}`}>
                
                <p>© 2026 Uber Technologies Inc.</p>
                <p><a href="https://www.kokodigital.co.uk/" target="_blank" rel="noreferrer">Website developed by Koko Digital</a></p>
            </div>
        </>
    )
}
